"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Bell24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "bell-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M14.8289758,21.0009007 C14.4168852,22.1656226 13.3058822,23 12,23 C10.6941178,23 9.58311485,22.1656226 9.17102423,21.0009007 Z M3,20 L3,18 L4,18 L4,10 C4,6.4720467 6.28366004,3.47747078 9.45339594,2.41385644 C9.98257852,1.56511011 10.925295,1 12,1 C13.074705,1 14.0174215,1.56511011 14.5472086,2.41438955 C17.71634,3.47747078 20,6.4720467 20,10 L20,18 L21,18 L21,20 L3,20 Z M12,4 C8.6862915,4 6,6.6862915 6,10 L6,18 L18,18 L18,10 C18,6.6862915 15.3137085,4 12,4 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function Bell24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Bell24Svg, Object.assign({}, svgProps)));
}
exports.default = Bell24;
//# sourceMappingURL=Bell24.js.map